import { TPageContentItem } from '@src/types/wysiwyg_editor';
import { isImage } from '@src/utils/wysiwyg_editor/data';
import { useCallback } from 'react';
import useSetImageContent from './useSetImageContent';

type PopulateFunction = (
  oldPageItems: Array<TPageContentItem>,
  newPageItems: Array<TPageContentItem>
) => void;

function useAutoPopulateImagesInLayout(): PopulateFunction {
  const setImageContent = useSetImageContent();

  const autoPopulateImagesInLayout = useCallback<PopulateFunction>(
    (oldPageItems, newPageItems) => {
      const newImages = newPageItems.filter(isImage);

      // auto-populate images in the next layout
      oldPageItems
        .filter(isImage)
        .filter((image) => image.href)
        .forEach((image, index) => {
          const targetItem = newImages[index];

          if (!targetItem) return;

          setImageContent(
            targetItem,
            {
              url: image.href,
              naturalDimensions: {
                height: image.naturalDimensions.height,
                width: image.naturalDimensions.width
              }
            },
            { saveSnapshot: false }
          );
        });
    },
    [setImageContent]
  );

  return autoPopulateImagesInLayout;
}

export default useAutoPopulateImagesInLayout;
